import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import Image from 'next/image';

export default function PharmaceuticalCompanies() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" py={6}>
        <Container>
          <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
            <b>
              Mind the Graph's trusted by researchers and professionals
              <br /> from 100+ biotechnology and pharmaceutical companies
            </b>
          </Typography>

          <Box className={classes.mainBoxImages} pt={6}>
            <Image
              src="/images/logos-academics-institutions/gsk-icon.png"
              alt="gsk icon"
              loading="lazy"
              width={202}
              height={82}
            />

            <Image
              src="/images/logos-academics-institutions/astrazeneca-icon.png"
              alt="astrazeneca icon"
              loading="lazy"
              width={202}
              height={55}
            />

            <Image
              src="/images/logos-academics-institutions/ipsen-icon.png"
              alt="ipsen icon"
              loading="lazy"
              width={138}
              height={39}
            />

            <Image
              src="/images/logos-academics-institutions/novo-nordisk-icon.png"
              alt="nordisk icon"
              loading="lazy"
              width={123}
              height={89}
            />

            <Image
              src="/images/logos-academics-institutions/sanofi-icon.png"
              alt="sanofi icon"
              loading="lazy"
              width={157}
              height={37}
            />
          </Box>

          <Box className={classes.mainBoxImages} pt={2}>
            <Image
              src="/images/logos-academics-institutions/edanz-logo.png"
              alt="edanz icon"
              loading="lazy"
              width={171}
              height={40}
            />

            <Image
              src="/images/logos-academics-institutions/servier-icon.png"
              alt="servier icon"
              loading="lazy"
              width={132}
              height={46}
            />

            <Image
              src="/images/logos-academics-institutions/pfizer-icon.png"
              alt="pfizer icon"
              loading="lazy"
              width={77}
              height={50}
            />

            <Image
              src="/images/logos-academics-institutions/novartis-icon.png"
              alt="novartis icon"
              loading="lazy"
              width={205}
              height={52}
            />

            <Image
              src="/images/logos-academics-institutions/solvay-icon.png"
              alt="solvay icon"
              loading="lazy"
              width={97}
              height={97}
            />
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
